import axios from "axios";
import Config from "@/config"

export default class RecipeService {
    async getRecipes() {
        const options = {
            headers: { ...Config.headers() },
            params: {
                fields: "code,name"
            },
        };
        return await axios
            .get(
                Config.proxy + Config.url("languages"),
                options
            )
            .then(res => res.data);
    }
 }